/* eslint-disable no-unused-vars */
import { TimesheetSubmitResult } from '@/shared/constants/timesheet/TimesheetSubmitResult'

export default class TimesheetResultModel {
  constructor({ bookingId, status } = {}) {
    /**
     * @type {Number}
     */
    this.bookingId = bookingId

    /**
     * @type {String}
     * @see {TimesheetSubmitResult} for accepted values
     */
    this.status = status
  }
}
